function formatDateTime(timestamp) {
  if (!timestamp) return "-";

  const date = new Date(Number(timestamp) * 1000);

  return date
    .toLocaleString("en-GB", {
      day: "2-digit",
      month: "2-digit",
      year: "numeric",
      hour: "2-digit",
      minute: "2-digit",
      hour12: true,
    })
    .replace(/am|pm/gi, (match) => match.toUpperCase());
}

module.exports = { formatDateTime };
